import { Controller } from "@hotwired/stimulus"

/**
 * Export Modal Controller
 *
 * Handles opening export modals for users and admins.
 * This controller provides a simple action to toggle Bootstrap modals
 * without jQuery dependencies.
 *
 * Usage:
 *   <button data-action="click->export-modal#open"
 *           data-export-modal-target-param="exportUsersModal">
 *     Export
 *   </button>
 *
 *   <div id="exportUsersModal" class="modal fade">...</div>
 */
export default class extends Controller {
  /**
   * Open a modal by ID
   *
   * @param {Event} event - Click event from button
   */
  open(event) {
    event.preventDefault()

    // Get modal ID from data attribute (data-export-modal-target-param)
    const modalId = event.currentTarget.dataset.exportModalTargetParam

    if (!modalId) {
      console.error('No modal ID specified in data-export-modal-target-param')
      return
    }

    const modalElement = document.getElementById(modalId)
    if (!modalElement) {
      console.error(`Modal not found: ${modalId}`)
      return
    }

    // Open the modal using Bootstrap's modal API
    const modal = new bootstrap.Modal(modalElement)
    modal.show()
  }
}
